import React, { createContext, useContext } from "react";
import { getLandingCopy, LandingCopy, LandingLanguage } from "./landingCopy";

// Without a provider (a section rendered on its own, a test) the copy is English.
const LandingLanguageContext = createContext<LandingLanguage>("en");

export const LandingLanguageProvider = React.memo(function LandingLanguageProvider({
  language,
  children,
}: {
  language: LandingLanguage;
  children: React.ReactNode;
}) {
  return <LandingLanguageContext.Provider value={language}>{children}</LandingLanguageContext.Provider>;
});

export function useLandingLanguage(): LandingLanguage {
  return useContext(LandingLanguageContext);
}

// The visitor-facing strings of the landing sections, in the language of the page being viewed.
export function useLandingCopy(): LandingCopy {
  return getLandingCopy(useLandingLanguage());
}
